<main>
  <button class="toggle" (click)="switchTheme()">
    {{ theme === "light-theme" ? "Switch to dark" : "Switch to light" }}
  </button>

  <div class="box">
    <h1 class="header">Header Text</h1>
    <p class="paragraph">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam minima
      accusantium quod suscipit saepe sit natus adipisci dolores ipsa doloribus
      iusto dolor, eum expedita quae optio aut repellendus. Aliquam, totam.
    </p>
  </div>
  <div class="box">
    <h1 class="header">Header Text</h1>
    <p class="paragraph">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam minima
      accusantium quod suscipit saepe sit natus adipisci dolores ipsa doloribus
      iusto dolor, eum expedita quae optio aut repellendus. Aliquam, totam.
    </p>
  </div>
  <div class="box">
    <h1 class="header">Header Text</h1>
    <p class="paragraph">
      Lorem ipsum dolor sit amet consectetur adipisicing elit. Aliquam minima
      accusantium quod suscipit saepe sit natus adipisci dolores ipsa doloribus
      iusto dolor, eum expedita quae optio aut repellendus. Aliquam, totam.
    </p>
  </div>
</main>
